export default "/images/he.png?eb4994c4eb6d00a55e772ea734d27dc3";